import React from 'react';
import PropTypes from 'prop-types';
import styles from './Radio.module.scss';
import omit from 'lodash-es/omit';

function Radio(props) {
  return (
    <div
      className={styles.container + ' ' + props.className + ' ' + props.theme}
    >
      {props.label ? (
        <label htmlFor={props.id} className={styles.label}>
          {props.label}
        </label>
      ) : null}
      <label htmlFor={props.id} className={styles.radioContainer}>
        <input {...omit(props, ['className'])} type="radio" />
        <span className={styles.radioDisplay}>
          <div className={styles.circle} />
        </span>
      </label>
    </div>
  );
}

Radio.THEME = {
  orange: styles.radioOrange,
  white: styles.radioWhite,
};

Radio.defaultProps = {
  theme: styles.radioOrange,
};

Radio.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  theme: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

export default Radio;
